module.exports = __webpack_public_path__ + "img/DieWand.4214742c.svg";